import { Box, CardHeader, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Alert, Autocomplete } from "@mui/material";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import ReactCountryFlag from "react-country-flag";
import { NavLink } from "react-router-dom";
import { CoatOfArms } from "../../../components/CoatOfArms";
import { LoadingWrapper } from "../../../components/LoadingWrapper";
import { Config } from "../../../config/config";
import { CountryCodes } from "../../../utils/countryCodes";
import { Helpers } from "../../../utils/helpers";

export class DashboardTopAlliances extends React.Component<any, any> {

	constructor(props) {
		super(props);

		this.state = {
			alliances: [],
			loading: true,
			error: null,
			filter: {
				country: null,
			}
        };
    }

	componentDidMount() {
		this.loadStats();
	}

	loadStats() {
        this.setState({ loading: true }, async () => {
			try {
				const response = await axios.post(`${Config.getInstance.apiUrl}/api/dashboard/top_alliances`, {
					...this.state.filter
				}, {
					headers: {
						Authorization: Helpers.getSessionId(),
					},
				});

				this.setState({
					alliances: response.data.list,
					loading: false,
				});
			} catch (error) {
				this.setState({
					error: error.message,
					loading: false,
				});
			}
		})
    }

	handleFilter(property: string, value: any) {
        const filterForm = {...this.state.filter};
        filterForm[property] = value;

        this.setState({ filter: filterForm }, () => {
			this.loadStats();
		});
    }

	renderCardHeaderActions() {
		return <Grid container spacing={2}>
			<Grid item xs={4}>
				<Autocomplete
					style={{ display: "inline-block", minWidth: 200, padding: "8px 5px 0 0" }}
					onChange={(_, newValue) => this.handleFilter("country", newValue)}
					value={this.state.filter.country}
					options={CountryCodes.sort((a, b) => -b.name.localeCompare(a.name))}
					getOptionLabel={option => option?.name || ""}
					renderOption={(props, item) => (
						<Box component="li" {...props}>
							<ReactCountryFlag countryCode={item.code} svg={true}/>
							<span style={{ marginLeft: 7, fontSize: 15 }}>{item.name}</span>
						</Box>
					)}
					renderInput={(params) =>
						<TextField
							{...params}
							label="Country"
							variant="outlined"
							size="small"
						/>
					}
				/>
			</Grid>
		</Grid>;
	}

	renderTableBody() {
		if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={7}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

		if ((this.state?.alliances || []).length === 0) {
			return <TableCell colSpan={7}>
				<Alert severity="info">No alliances found</Alert>
			</TableCell>
		}

		return (this.state?.alliances || []).map(item => (
			<TableRow key={item.id} hover={true} style={{ height: 100 }}>
				<TableCell><CoatOfArms emblem={item.flag}/></TableCell>
				<TableCell>
					<NavLink to={`/alliances/${item.id}`}>
						{item.name}
					</NavLink>
				</TableCell>
				<TableCell>{item.tag}</TableCell>
				<TableCell>
					{item.country !== "IA" && <ReactCountryFlag countryCode={item.country} svg={true}/>}
					<span style={{ marginLeft: 5, fontSize: 12 }}>{item.country}</span>
				</TableCell>
				<TableCell style={{ ...(item.members_count === item.max_members && { color: "#81c784" }) }}>
					{item.members_count}/{item.max_members}
				</TableCell>
				<TableCell>{item.current_rank}</TableCell>
				<TableCell>{moment(item.created_at).format("DD.MM.YYYY")}</TableCell>
			</TableRow>
		))
	}

	render() {
		return <Paper elevation={0}>
			<div>
				<CardHeader
					title={<Typography variant="h6">Top 10 alliances</Typography>}
					action={this.renderCardHeaderActions()}
				/>

				<Table>
					<TableHead>
						<TableRow>
							<TableCell style={{ width: 50, padding: "4px 16px" }}></TableCell>
							<TableCell style={{ padding: "4px 16px" }}>Name</TableCell>
							<TableCell style={{ width: 120, padding: "4px 16px"}}>Tag</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px"}}>Country</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px"}}>Members</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px"}}>Rank</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px"}}>Created at</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{this.renderTableBody()}
					</TableBody>
				</Table>
			</div>
		</Paper>;
	}
}
